import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import MainLayout from "./components/MainLayout";
import PopupForm from "./components/PopupForm";
import { PopupProvider } from "./context/PopupContext";
import { Toaster } from "./components/ui/sonner";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Landing from "./pages/Landing";
import ApplicationMain from "./pages/ApplicationMain";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Thank from "./pages/Thank";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PopupProvider>
          <Routes>
            {/* Standalone pages without main nav */}
            <Route path="/lp" element={<Landing />} />
            <Route path="/application/main" element={<ApplicationMain />} />
            <Route path="/thank" element={<Thank />} />

            {/* Main website (shared layout) */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/terms-and-conditions" element={<Terms />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
          <PopupForm />
          <Toaster />
        </PopupProvider>
      </BrowserRouter>
    </div>
  );
}
